import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
// Element Plus ships its own strings - "No Data", "Total", the "To" between
// two dates - and they were surfacing untranslated in an Italian interface.
import it from 'element-plus/es/locale/lang/it'
import 'element-plus/dist/index.css'
// Must come after Element Plus so the token bridge wins (see styles/tokens.css)
import './styles/tokens.css'
import { initTheme } from './styles/theme'

import App from './App.vue'
import router from './router'

// Check bypass mode from env var (used in auth store)
import { loadDemoCustomRoles } from '@/config/demoRole'

const BYPASS_MODE = import.meta.env.VITE_AUTH_BYPASS === 'true'
void BYPASS_MODE // Mark as used (referenced in auth store)

initTheme()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
// La traduzione italiana di Element Plus lascia `pagesize` in inglese ("20/page").
app.use(ElementPlus, {
  locale: { ...it, el: { ...it.el, pagination: { ...it.el.pagination, pagesize: '/pagina' } } }
})

// I ruoli personalizzati vanno letti prima di installare il router: `app.use(router)`
// avvia la prima navigazione, e resolveDemoRole() e' sincrona - con il registro
// ancora vuoto un nome valido ricadrebbe su unauthorized, e la guardia manderebbe
// un link diretto su /unauthorized.
loadDemoCustomRoles().finally(() => {
  app.use(router)
  app.mount('#app')
})

// Note: Google GIS SDK is loaded via script tag in index.html
// GIS SDK initialization happens in auth store login() method
